import { AppTextField, FieldInfoMessage } from 'components/form-fields';
import { getTrans } from 'modules/i18n';

export const BasicInfoFields = () => (
  <>
    <AppTextField
      sx={{ mb: 2, mt: 1 }}
      data-dd-privacy="mask"
      name="personalDetails.firstname"
      label={getTrans('cvBuilderPage.personalDetails.form.firstName.label')}
      variant="outlined"
      fullWidth
    />
    <AppTextField
      sx={{ mb: 2 }}
      data-dd-privacy="mask"
      name="personalDetails.lastname"
      label={getTrans('cvBuilderPage.personalDetails.form.lastName.label')}
      variant="outlined"
      fullWidth
    />
    <AppTextField
      sx={{ mb: 1 }}
      data-dd-privacy="mask"
      name="personalDetails.email"
      label={getTrans('cvBuilderPage.personalDetails.form.email.label')}
      variant="outlined"
      fullWidth
    />
    <FieldInfoMessage
      helperText={getTrans(
        'cvBuilderPage.personalDetails.form.email.helperText'
      )}
    />
    <AppTextField
      sx={{ mb: 2 }}
      data-dd-privacy="mask"
      name="personalDetails.phone"
      label={getTrans('cvBuilderPage.personalDetails.form.phoneNumber.label')}
      variant="outlined"
      fullWidth
    />
    <AppTextField
      sx={{ mb: 2 }}
      data-dd-privacy="mask"
      name="personalDetails.zip"
      label={getTrans('cvBuilderPage.personalDetails.form.zipCode.label')}
      variant="outlined"
      fullWidth
    />
  </>
);
